import safeAreaInsets from 'safe-area-insets'

// Setup function for Vue 3
export const setupSafeAreaInsets = app => {
  app.config.globalProperties.$safeArea = safeAreaInsets
}

// Export safeAreaInsets directly for use in Composition API
export default safeAreaInsets
